import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import logo from '../../assets/yapa-logo.png';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import { isAxiosError } from 'axios';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import './Navbar.css';

const PDF_URL = '/auth/logout';
const HELP_URL = "https://docs.google.com/document/d/1uDv1Mq8UnN6HuYHH3boAxxDIqXULEdTS-HwQx1cNkDQ/edit?tab=t.0#heading=h.spwxl1h75mn5";

const Navbar = () => {
  const { auth } = useAuth();
  const navigate = useNavigate();
  const axiosPrivate = useAxiosPrivate();
  const [canEdit, setCanEdit] = useState(true);
  const EDIT_PERMISSION_URL = `/bands/edit-permission/${auth.email}`;

  useEffect(() => {
    const fetchEditPermission = async () => {
      try {
        const response = await axiosPrivate.get(EDIT_PERMISSION_URL);
        setCanEdit(response.data.mozeEdytowac !== 0);
      } catch (error) {
        console.error("Błąd pobierania uprawnień edycji", error);
        setCanEdit(false);
      }
    };

    fetchEditPermission();
  }, [axiosPrivate]);

  const handleLogout = async () => {
    try {
      const response = await axiosPrivate.get(PDF_URL);
      if (response.status === 204) {
        localStorage.removeItem('token');
        navigate('/');
        console.log('Pomyślnie wylogowano');
      }
    } catch (error) {
      if (isAxiosError(error)) {
        if (error.response && error.response.status === 403) {
          navigate('/');
        }
      }
    }
  };

  return (
    <div className="navabar-container">
      <img 
        onClick={() => auth.role === 'admin' && navigate('/admin')} 
        src={logo} 
        width={200} 
        alt="Logo YAPA" 
        style={{ cursor: auth.role === 'admin' ? 'pointer' : 'default' }}
      />
      {!canEdit && <p className="edit-warning">Brak możliwości edycji!</p>}
      <div className="navbar-content">
        <div className="user-info">
          <p>
            Zalogowano jako: {auth?.email ? auth.email : 'example@email.com'}
          </p>
          <Button id='help-button' href={HELP_URL} target='_blank' rel="noopener noreferrer" color='primary'>Pomoc</Button>
          <Button onClick={handleLogout}>Wyloguj</Button>
        </div>
        <ButtonGroup
          variant="contained"
          size="large"
          sx={{
            button: {
              margin: '2px',
              borderRadius: '0',
              width: '200px',
              height: '50px',
            },
          }}
        >
          {auth?.role === 'program' ? (
            <Button onClick={() => navigate('/artists')}>Gwiazdy</Button>
          ) : (
            <>
              <Button onClick={() => navigate('/band')}>Dane Zespołu</Button>
              <Button onClick={() => navigate('/song')}>Piosenki</Button>
              <Button onClick={() => navigate('/summary')}>Podsumowanie</Button>
            </>
          )}
        </ButtonGroup>
      </div>
    </div>
  );
};

export default Navbar;
